//#region IMPORT
import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CommonActions } from '../../../../Reducer/CommonReducer';
import { NavBarInfoActions } from '../../../../Reducer/NavBarInfoReducer';
import M_FILE_CUSTOM from './M_FILE_CUSTOM';
import { useBackStack } from '../../../../Hooks/back/useBackStack';
//#endregion

function M_FILE_CUSTOMF() {
  //#region 변수
  const { userInfo } = useSelector((state) => state.BaseInfo);
  const dispatch = useDispatch();
  const activeStep = useSelector((state) => state.common.activeStep);
  //#endregion

  //#region 이벤트
  useEffect(() => {
    dispatch(NavBarInfoActions.setType('titleBar'));
    dispatch(NavBarInfoActions.setTitleName('교육 파일'));
    dispatch(CommonActions.setActiveStep(0));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 스택형 뒤로가기: activeStep === 0 일 때는 guard 없음 → 스택이 page 타입 처리해서 자동으로 이전 페이지로 이동
  const activeStepRef = useRef(activeStep);
  useEffect(() => {
    activeStepRef.current = activeStep;
  }, [activeStep]);

  useBackStack({
    type: 'step',
    enabled: activeStep > 0,
    onBack: () =>
      dispatch(CommonActions.setActiveStep(activeStepRef.current - 1)),
  });

  //#endregion

  return (
    <div className="wrap">
      <M_FILE_CUSTOM userInfo={userInfo} activeStep={activeStep} />
    </div>
  );
}

export default M_FILE_CUSTOMF;
